export default "__VITE_ASSET__dbe3fba0__"